import type { RouteRecordRaw } from 'vue-router';

const routes: RouteRecordRaw[] = [
  {
    path: '/user',
    component: () => import('layouts/MainLayout.vue'),
    children: [
      { path: '', component: () => import('src/pages/Dashboard.vue') },
      { path: 'dashboard', component: () => import('src/pages/Dashboard.vue') },
      {
        path: 'servicestatus/:service_id',
        component: () => import('pages/ServiceStatus.vue'),
      },
      {
        path: 'profile',
        component: () => import('pages/user/Profile.vue'),
      },
      {
        path: 'cancellation',
        component: () => import('pages/user/Cancellation.vue'),
      },
      {
        path: 'alerts',
        component: () => import('pages/user/AlertList.vue'),
      },
      {
        path: 'notification',
        component: () => import('pages/user/Notification.vue'),
      },
    ],
  },
  {
    path: '/data',
    component: () => import('layouts/MainLayout.vue'),
    children: [
      { path: '', component: () => import('src/pages/Dashboard.vue') },
      {
        path: 'requestlist',
        component: () => import('pages/data/RequestList.vue'),
      },
      {
        path: 'search',
        component: () => import('pages/data/DataSearch.vue'),
      },
      // {
      //   path: 'upload',
      //   component: () => import('pages/data/UploadDB.vue'),
      // },
      {
        path: 'detail/:_id',
        component: () => import('pages/data/DetailDB.vue'),
      },
      {
        path: 'detail/:_id/:ref_page',
        component: () => import('pages/data/DetailDB.vue'),
      },
      {
        path: 'dblist',
        component: () => import('pages/data/DatabaseList.vue'),
      },
      {
        path: 'db_detail/:id',
        component: () => import('pages/data/DatabaseDetail.vue'),
      },
      {
        path: 'tablelist',
        component: () => import('pages/data/DBList.vue'),
      },
      {
        path: 'batch_upload',
        component: () => import('pages/data/BatchUpload.vue'),
      },
      {
        path: 'db_file_designate',
        component: () => import('pages/data/DbFileDesignate.vue'),
      },
      {
        path: 'db_sync',
        component: () => import('pages/data/DBSync.vue'),
      },
      {
        path: 'rules',
        component: () => import('pages/data/RuleManagement.vue'),
      },
      {
        path: 'codebook_list',
        component: () => import('pages/data/CodebookList.vue'),
      },
    ],
  },
  {
    // QUALITY 섹션 — 데모 페이지(분석 추가 / 분석 이력) + ErrorNotFound fallback.
    path: '/quality',
    component: () => import('layouts/MainLayout.vue'),
    children: [
      { path: 'add_analysis',   component: () => import('pages/quality/AddAnalysis.vue') },
      { path: 'analysis_list',  component: () => import('pages/quality/AnalysisHistory.vue') },
      { path: 'analysis/:aid',  component: () => import('pages/quality/AnalysisResult.vue') },
      {
        path: 'term_standardization_result',
        component: () => import('pages/quality/TermStandardizationResult.vue'),
      },
      {
        path: 'db_diagnosis_result',
        component: () => import('pages/quality/DbDiagnosisResult.vue'),
      },
      {
        path: 'qc2_cleansing_result',
        component: () => import('pages/quality/Qc2CleansingResult.vue'),
      },
      { path: ':catchAll(.*)*', component: () => import('pages/ErrorNotFound.vue') },
    ],
  },
  {
    path: '/admin',
    component: () => import('layouts/MainLayout.vue'),
    children: [
      { path: 'dashboard',    component: () => import('src/pages/admin/AdminDashboard.vue') },
      { path: 'user_list',    component: () => import('src/pages/admin/UserList.vue') },
      { path: 'analysis_list', component: () => import('src/pages/admin/AnalysisList.vue') },
      { path: 'file_list',    component: () => import('src/pages/admin/FileList.vue') },
      { path: 'monitoring',   component: () => import('src/pages/admin/Monitoring.vue') },
      { path: 'server_monitoring', component: () => import('src/pages/admin/ServerMonitoring.vue') },
      { path: 'notification', component: () => import('src/pages/admin/NotificationManagement.vue') },
      { path: 'db',          component: () => import('src/pages/admin/DbManagement.vue') },
      { path: 'reset',       component: () => import('src/pages/admin/Reset.vue') },
    ],
  },
  {
    path: '/',
    component: () => import('layouts/BlankLayout.vue'),
    children: [
      { path: '', component: () => import('pages/SignIn.vue') },
      { path: 'signin', component: () => import('pages/SignIn.vue') },
      { path: 'signup', component: () => import('pages/SignUp.vue') },
      { path: 'setup', component: () => import('pages/AdminSetup.vue') },
    ],
  },

  // Always leave this as last one,
  // but you can also remove it
  {
    path: '/:catchAll(.*)*',
    component: () => import('pages/ErrorNotFound.vue'),
  },
];

export default routes;
